<template>
  <div class="visitor-suc">
    <div class="visitor-header">
        <img class="img" src="~@/assets/images/visitorsuc.png" alt="">
        <div class="title">{{title}}</div>
        <div class="desc">{{subTitle}}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '提交成功'
    },
    subTitle: {
      type: String,
      default: '感谢您的配合，祝您身体健康'
    }
  }
}
</script>
<style lang="scss" scoped>
.visitor-suc {
  min-height: 100vh;
}
.visitor-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 15px;
  padding: 70px 30px 30px 30px;
  background: #fff;
  line-height: 2;
  .img {
    width: 85px;
    margin: 5px auto 25px;
  }
  .title {
    text-align: center;
    font-weight: 600;
    font-size: 16px;
  }
  .desc {
    text-align: center;
    font-size: 14px;
    color:#757575;
  }
}
</style>
